export const PROJECT_DATA_TO_RETRIEVE = `
    enabledTools
    GTMCode
    code
`;
